import { api } from "../api";

/**
 * findAllDepartmentsByCustomerIdAndSecretaryIdListResponse - Function that finds on database all departments as select list   
 * /departments/list/{customerId}/{secretaryId}    
 * method GET 
 * @async-function
 */
const findAllDepartmentsByCustomerIdAndSecretaryIdListResponse = async (token: string, customerId: number, secretaryId: number) => {
    const response = await api.get(
        `/departments/list/${customerId}/${secretaryId}`, {
           headers: {
               'Authorization': `Bearer ${token}`
           }
        }
    );
    return response;
};

export default findAllDepartmentsByCustomerIdAndSecretaryIdListResponse;